"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTION_PRICING_COLUMNS = exports.serialiseSnapshot = exports.newSnapshot = exports.isFrozenVersion = void 0;
exports.parseSnapshot = parseSnapshot;
exports.frozenOption = frozenOption;
// A version frozen when it is issued to the client or replaced by a new version
// (hig_scopeversion.hig_ratesnapshot; DD 2026-10-06 answer 4 and 2026-10-22):
// for every option, what it was priced from (its rates, and the sections with
// their quantities, approved hours and job prices already applied), so the
// price never moves afterwards. Pure.
const pricing_ts_1 = require("./pricing.js");
const SNAPSHOT_SCHEMA_VERSION = 1;
/** Version statuses that are frozen: priced from the snapshot, never changed. */
const FROZEN_STATUSES = ['Issued', 'Superseded'];
const isFrozenVersion = (status) => typeof status === 'string' && FROZEN_STATUSES.includes(status);
exports.isFrozenVersion = isFrozenVersion;
const newSnapshot = (reason, frozenOn, pricingDate, options) => ({
    schemaVersion: SNAPSHOT_SCHEMA_VERSION,
    frozenOn,
    reason,
    pricingDate,
    options,
});
exports.newSnapshot = newSnapshot;
/** The stored text as a snapshot; null when the version has none. Any other version is refused rather than misread. */
function parseSnapshot(text) {
    if (!text)
        return null;
    const parsed = JSON.parse(text);
    if (parsed.schemaVersion !== SNAPSHOT_SCHEMA_VERSION) {
        throw new Error(`This version's frozen prices are in a format this app version can't read (schemaVersion ${String(parsed.schemaVersion)}).`);
    }
    return parsed;
}
const serialiseSnapshot = (snapshot) => JSON.stringify(snapshot);
exports.serialiseSnapshot = serialiseSnapshot;
/** An option as it was frozen: its rates, sections and price; null when the snapshot doesn't hold it. */
function frozenOption(snapshot, optionId) {
    const option = snapshot?.options.find((o) => o.optionId.toLowerCase() === optionId.toLowerCase());
    return option ? { rates: option.rates, sections: option.sections, priced: (0, pricing_ts_1.priceOption)(option.sections, option.rates) } : null;
}
/** An option's pricing choices: what a new version copies, and what a frozen version or an accepted option may not change. */
exports.OPTION_PRICING_COLUMNS = ['hig_kind', 'hig_labourtype', 'hig_scope', 'hig_markupmaterials', 'hig_markupother', 'hig_negotiatingfactor', 'hig_termyears', 'hig_maintenancetier'];
